import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import channel_campaign_statuses_options from "utils/select_options/channel_campaign_statuses_options";

import { Dashboard, Select } from "components";

import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const BasicData = ({
  channel_id,
  channel_campaign,
  refetch,
  handleSubmit,
  change,
  pristine,
  invalid,
  initialValues,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/channels/${channel_id}/channel_campaigns/${channel_campaign?.id}`,
    onSuccess: refetch,
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Podstawowe informacje", icon: "info" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Input
          label="Kategoria"
          disabled
          meta={{}}
          input={{
            name: "root_taxon_id",
            value: channel_campaign?.root_taxon?.id
              ? `${channel_campaign.root_taxon.name} [${channel_campaign.root_taxon.identifier}]`
              : "Brak",
          }}
        />
        <Input
          label="ID zewnętrzne"
          disabled
          meta={{}}
          input={{
            name: "external_id",
            value: channel_campaign?.external_id,
          }}
        />
        <Field name="name" label="Nazwa" component={InputField} type="text" />
        <Field
          name="status"
          label="Status"
          component={SelectField}
          options={channel_campaign_statuses_options}
          handleChange={(value) => change("status", value)}
          defaultValue={channel_campaign_statuses_options.find(
            ({ value }) => value === initialValues.status,
          )}
        />
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa jest wymagana!";
  }

  if (!values.status) {
    errors.status = "Status jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "update-channel-campaign",
  enableReinitialize: true,
  validate,
})(BasicData);
